import React from 'react';
import { Check, Lock, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section id="final-cta" className="py-32 bg-background relative overflow-hidden" data-id="element-18">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center bottom, rgba(0,214,143,0.07) 0%, transparent 70%)'
    }} data-id="element-19"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} data-id="element-21">
          <h2 className="font-heading text-6xl md:text-8xl text-primary mb-4 leading-[0.9]" data-id="element-22">
            STOP BEING THE PERSON
            <br data-id="element-23" />
            <span className="text-muted" data-id="element-24">WHO JUST NODS AND SMILES.</span>
          </h2>
          <p className="font-heading text-4xl md:text-5xl text-accent-yellow mb-8" data-id="element-25">
            START BEING THE PERSON
            <br data-id="element-26" />
            PEOPLE ACTUALLY WANT TO TALK TO.
          </p>
          <p className="text-xl text-muted mb-12 max-w-xl mx-auto" data-id="element-27">
            This isn't a 6-month course. This is a 7-day identity upgrade. The
            scripts are ready. The only question is: are you?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="bg-surface border border-border rounded-3xl p-8 md:p-12 max-w-2xl mx-auto shadow-2xl" data-id="element-28">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8 border-b border-border pb-8 gap-4" data-id="element-29">
            <div className="text-left" data-id="element-30">
              <span className="text-muted text-sm uppercase tracking-widest" data-id="element-31">
                One-time payment
              </span>
              <div className="flex items-baseline gap-3 mt-1" data-id="element-32">
                <span className="font-heading text-6xl text-accent-yellow" data-id="element-33">
                  $6.39
                </span>
                <span className="text-muted line-through text-xl" data-id="element-34">$31.95</span>
              </div>
            </div>
            <div className="bg-accent-yellow/10 text-accent-yellow px-4 py-2 rounded-full text-sm font-bold border border-accent-yellow/20" data-id="element-35">
              SAVE 80% TODAY
            </div>
          </div>

          <ul className="space-y-4 mb-8 text-left" data-id="element-36">
            {['Complete Social Survival Script Manual', '50+ Battle-Tested Conversation Scripts', 'The Audio-Mirror Method Training', 'Lifetime Updates & Access'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-37">
                <div className="bg-accent-yellow/15 p-1 rounded-full text-accent-yellow flex-shrink-0" data-id="element-38">
                  <Check size={14} data-id="element-39" />
                </div>
                <span className="text-primary" data-id="element-40">{item}</span>
              </li>)}
          </ul>

          <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
          window.location.href = 'https://www.versastorex.com/cart/42019072671824:1';
        }} className="w-full bg-accent-orange text-white font-bold py-5 px-8 rounded-xl text-xl transition-colors duration-200 shadow-[0_8px_30px_-8px_rgba(0,168,107,0.5)] hover:shadow-[0_8px_40px_-8px_rgba(0,168,107,0.7)] mb-6" data-id="element-41">
            YES — GIVE ME MY SCRIPTS NOW →
          </motion.button>

          <div className="flex flex-wrap justify-center gap-6 text-xs text-muted" data-id="element-42">
            <span className="flex items-center gap-1.5" data-id="element-43">
              <Lock size={12} data-id="element-44" /> Secure Checkout
            </span>
            <span className="flex items-center gap-1.5" data-id="element-45">
              <Zap size={12} data-id="element-46" /> Instant Access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-47">
              💰 30-Day Money Back
            </span>
          </div>

          <p className="text-xs text-muted/60 italic mt-4" data-id="element-48">
            ⚡ Price increases at midnight.
          </p>
        </motion.div>
      </div>
    </section>;
}